import axios from 'axios';

// Used for to populate user state on initial load and reset user state on logout
const getUserDefaultState = () => {
	return {
		loggedIn: false,
		user: null,
		accessTokenValidTimestamp: null,
		overrideHostUser: null,
	}
}

export default {
	namespaced: true,
	state: getUserDefaultState(),
	getters: {
		loggedIn: (state) => state.loggedIn,
		user: (state) => state.user,
		activeUser: (state) => {
			if (state.overrideHostUser !== null) {
				return {
					...state.user,
					...state.overrideHostUser,
				}
			}

			return state.user;
		},
	},
	mutations: {
		mutateUserStateToDefault(state) {
			Object.assign(state, getUserDefaultState())
		},
		mutateLoggedInUserData(state, user) {
			//console.log(`%cUser data set to:`, 'color: yellow; padding: 5px 0', user)
			state.user = user;
		},
		mutateLoggedIn(state, loggedIn) {
			if (loggedIn === false) {
				console.log(`%cLogged in set to:`, 'color: yellow; padding: 5px 0', false)
			}
			state.loggedIn = loggedIn;
		},
		mutateAccessTokenValidTimestamp(state, accessTokenValidTimestamp) {
			state.accessTokenValidTimestamp = accessTokenValidTimestamp;
		},
		mutateOverrideHostUser(state, user) {
			state.overrideHostUser = user;
		}
	},
	actions: {

		async logIn({ rootGetters, commit }) {
			const loginFormData = {
				username: "app.tester2@wisenetwork.fi",
				password: "Test1234"
			}
			try {
				const activeHost = rootGetters['common/activeHost'];
				const headers = {};
				let loginUrl = `${ activeHost.ajaxUrl }?action=ajaxauthorize&appauth=${activeHost.appauth}`;
				
				if (activeHost.sessionType) {
					axios.defaults.headers.common['x-session-type'] = activeHost.sessionType;
				}
				
				const { data } = await axios.post(
					loginUrl, 
					loginFormData,
					{ headers }
				);
				axios.defaults.headers.common['Authorization'] = `token ${ data.access_token }`;

				document.body.classList.add(activeHost.className.toLowerCase())

				commit('mutateLoggedInUserData', data)
				commit('mutateLoggedIn', true)
				
				return data;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data);
					return Promise.reject(error.response.data)
				} else {
					console.error(error)
					return Promise.reject(error)
				}
			}
		}
	}
}
